export const isDateValid = (date: Date) =>
  // biome-ignore lint/suspicious/noGlobalIsNan: migrated from develop
  date instanceof Date && !isNaN(date.valueOf());
